import { GeoJSONSource } from "maplibre-gl";
import { useEffect } from "react";
import { emptyFeatureCollection } from "../../../util/geo";
import { useCaMap, useIsSection, useSelection } from "../../state";
import { Cube } from "../../state/types";
import { toGeometryCollection, useSetLayoutProperty, zoomTo } from "../util";

export const BuildingsControl = ({ id }) => {
  const map = useCaMap();
  const buildings = useSelection(
    ({ state, cube }) => state === "fetched" && cube?.builtUp?.buildings
  );
  useEffect(() => {
    const data = buildings ? toGeometryCollection(buildings) : emptyFeatureCollection;
    (map?.getSource(id) as GeoJSONSource)?.setData(data);
  }, [map, buildings, id]);

  const visible = useIsSection("") ? "visible" : "none";
  useSetLayoutProperty(map, "buildings", "visibility", visible);
  return null;
};

export const SelectControl = ({ id }) => {
  // show selected field + buildings
  const map = useCaMap();
  const cube: Cube = useSelection((s) => s.state === "fetched" && s.cube);
  useEffect(() => {
    if (!map) return;
    const s = map.getSource(id) as GeoJSONSource;
    s?.setData(cube?.geometry || emptyFeatureCollection);
    if (cube?.center && !map.getBounds().contains(cube.center)) {
      // if selected feature not in view, panto feature
      zoomTo(map, cube.geometry);
    }
  }, [map, cube, id]);
  return null;
};
